// extracted by mini-css-extract-plugin
export default {"exchange-rate-label":"cross_exchange-rate-label__YrZpi","exchange-rate-container":"cross_exchange-rate-container__l6nR1"};